export const real_estate_living = [
  { char: '🏠', name: 'House', nameZh: '溫馨成家', keywords: ['home', 'buy', 'living', '買房'], hot: true },
  { char: '🏢', name: 'Office', nameZh: '商辦大樓', keywords: ['city', 'work', 'business'] },
  { char: '🏘️', name: 'Houses', nameZh: '社區環境', keywords: ['neighborhood', 'living', 'home'] },
  { char: '🏙️', name: 'Cityscape', nameZh: '都市景觀', keywords: ['city', 'view', 'night'] },
  { char: '🔑', name: 'Key', nameZh: '交屋入厝', keywords: ['lock', 'open', 'new', '鑰匙'], hot: true },
  { char: '🛋️', name: 'Couch', nameZh: '居家美學', keywords: ['interior', 'design', 'relax', '裝潢'], hot: true },
  { char: '🖼️', name: 'Picture', nameZh: '藝術裝飾', keywords: ['art', 'home', 'style'] },
  { char: '🪟', name: 'Window', nameZh: '採光通風', keywords: ['view', 'light', 'glass'] },
  { char: '🏗️', name: 'Construction', nameZh: '建案工程', keywords: ['build', 'work', 'crane'] },
  { char: '🛁', name: 'Bathtub', nameZh: '衛浴空間', keywords: ['bathroom', 'clean', 'relax'] },
  { char: '🪜', name: 'Ladder', nameZh: '修繕/進步', keywords: ['fix', 'up', 'tool'] },
  { char: '🪴', name: 'Potted Plant', nameZh: '室內綠植', keywords: ['nature', 'green', 'home'] },
];